const doc = [({"installment":"Plată în rate", "limited_subscription":"Abonament limitat", "one_time":"O singură dată", "subscription":"Abonament"})];
module.exports = doc.length <= 1 ? doc[0] : doc;